import api from '../api/client';

export interface DashboardWidget {
  id: string;
  widgetType: string;
  column: number;
  order: number;
  config?: Record<string, any>;
}

export interface DashboardLayout {
  widgets: DashboardWidget[];
}

export interface AvailableWidget {
  type: string;
  name: string;
  nameEn: string;
  description: string;
  descriptionEn: string;
  icon: string;
  defaultColumn: number;
  implemented: boolean;
}

export const dashboardService = {
  /**
   * Hämta användarens dashboard-layout
   */
  async getLayout(): Promise<DashboardLayout> {
    const response = await api.get('/api/dashboard/layout');
    if (response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data.error || 'Failed to get dashboard layout');
  },

  /**
   * Spara användarens dashboard-layout
   */
  async saveLayout(layout: DashboardLayout): Promise<void> {
    const response = await api.put('/api/dashboard/layout', layout);
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to save dashboard layout');
    }
  },

  /**
   * Hämta tillgängliga widgets
   */
  async getAvailableWidgets(): Promise<AvailableWidget[]> {
    const response = await api.get('/api/dashboard/widgets/available');
    if (response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data.error || 'Failed to get available widgets');
  },

  /**
   * Lägg till en widget
   */
  async addWidget(widgetType: string, column: number = 0): Promise<DashboardWidget> {
    const response = await api.post('/api/dashboard/widgets', { widgetType, column });
    if (response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data.error || 'Failed to add widget');
  },

  /**
   * Ta bort en widget
   */
  async removeWidget(widgetId: string): Promise<void> {
    const response = await api.delete(`/api/dashboard/widgets/${widgetId}`);
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to remove widget');
    }
  },
};

